import useQueryParam from "hooks/useQueryParam";
import { GET_PARAMS } from "constants/popupConfig";
import { useMemo } from "react";
import { useGetParam } from "hooks/useGetParam";
import { useSelector } from "react-redux";
import * as gamesSelector from "redux/game/selectors";
import {
  CATEGORIES_ENUMS,
  CATEGORIES_FOR_SEO,
} from "constants/navigation/categories";
import "./SEOH1.sass";
import { useParams } from "react-router-dom";
import useTranslate from "hooks/useTranslate";

interface SEOH1Props {
  title?: string;
}

const SEOH1 = (props: SEOH1Props) => {
  const { title } = props;
  const providersQuery = useQueryParam(GET_PARAMS.PROVIDERS);
  const { category, game } = useGetParam();
  const games = useSelector(gamesSelector.games);
  const params = useParams();
  const t = useTranslate();

  const currentGame = useMemo(() => {
    if (games && params.game) {
      return games.find((g) => g.urlAlias === params.game) || null;
    }
    return null;
  }, [games, params]);

  const generatedTitle = useMemo(() => {
    if (providersQuery) {
      return `${t("provider.title.main")} ${providersQuery.replace(/,/g, ", ")}`;
    }
    if (category === CATEGORIES_ENUMS.LIVE_CASINO) {
      return `${t("provider.title.main")} Evolution, PragmaticPlayLive, Ezugi`;
    }
    if (category && game && currentGame) {
      return `${CATEGORIES_FOR_SEO[category]} ${currentGame.name}`;
    }
    return "";
  }, [providersQuery, currentGame, category, game, t]);

  return <h1 className="SEOH1">{generatedTitle || title || ""}</h1>;
};

export default SEOH1;
